import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/layout/AdminLayout';
import * as FaIcons from 'react-icons/fa';
import moment from 'moment';


import AdminInterestContext from '../../context/adminInterest/adminInterestContext';
import InterestContext from '../../context/interest/interestContext';

import SiteZipSearchModal from '../../components/interestAdmin/SiteZipSearchModal';
import SiteFieldSearchModal from '../../components/interestAdmin/SiteFieldSearchModal';

import countriesList from '../../data/countriesList';
import states from '../../data/states';
import relationshipList from '../../data/relationshipList';
import ErrorLogger from "../../components/ErrorLogger";
import llacFav from "../../img/LLAC-favicon.ico";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";

const AddInterestPage = () => {
  const navigate = useNavigate();
  const interestContext = useContext(InterestContext);
  const { submitData, sendInterestEmail } = interestContext;
  const adminInterestContext = useContext(AdminInterestContext);
  const {
    formModal: { siteZipSearchModal, siteFieldSearchModal },
    setFormModal,
    getSearchSites,
    searchSites,
  } = adminInterestContext;
  const [validationError, setValidationError] = useState(false);
  const [age, setAge] = useState(0);
  const [formData, setFormData] = useState({
    studentId: '',
    studentNumber: '',
    studentFirstName: '',
    studentLastName: '',
    gradeLevel: '',
    birthDate: '',
    parentRelationship: '',
    parentFirstName: '',
    parentLastName: '',
    primaryEmail: '',
    phone: '',
    street1: '',
    street2: '',
    state: '',
    region: '',
    city: '',
    country: '',
    zipCode: '',
    sameAddress: '',
    mailingStreet1: '',
    mailingStreet2: '',
    mailingCity: '',
    mailingState: '',
    mailingRegion: '',
    mailingCountry: '',
    mailingZipCode: '',
    learningCenterName: '',
    learningCenterCharter: '',
    learningCenterAddress: '',
    learningCenterCoordinates: '',
    learningCenterId: '',
  });
  const {
    studentId,
    studentNumber,
    studentFirstName,
    studentLastName,
    gradeLevel,
    birthDate,
    parentRelationship,
    parentFirstName,
    parentLastName,
    primaryEmail,
    phone,
    street1,
    street2,
    state,
    region,
    city,
    country,
    zipCode,
    sameAddress,
    mailingStreet1,
    mailingStreet2,
    mailingCity,
    mailingState,
    mailingRegion,
    mailingCountry,
    mailingZipCode,
    learningCenterName,
    learningCenterCharter,
    learningCenterAddress,
  } = formData;

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var newAge = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      newAge--;
    }
    setAge(newAge);
  };

  useEffect(() => {
    getSearchSites();
  }, []);

  const onChangeForm = (e) => {
    if (e.target.name === 'birthDate') {
      getAge(e.target.value);
    }
    if (e.target.name === 'sameAddress') {
      setFormData({ ...formData, [e.target.name]: e.target.checked });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const siteInfoFilledOut =
    learningCenterName !== '' &&
    learningCenterCharter !== '' &&
    learningCenterAddress !== '';

  const intialFilledOut =
    studentFirstName !== '' &&
    studentLastName !== '' &&
    birthDate !== '' &&
    birthDate !== moment(new Date()).format('YYYY-MM-DD');
 
  const parentsInfoFilledOut =
    parentRelationship !== '' &&
    parentFirstName !== '' &&
    parentLastName !== '';

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };

  const getEmailFilledOut =
    primaryEmail !== '' &&
    validateEmail(primaryEmail) &&
    phone !== '' &&
    validatePhone(phone);

  const addressFiledOut =
    street1 !== '' &&
    city !== '' &&
    (state !== '' || region !== '') &&
    country !== '' &&
    zipCode !== '';

  const mailingFiledOut =
    mailingStreet1 !== '' &&
    mailingCity !== '' &&
    (mailingState !== '' || mailingRegion !== '') &&
    mailingCountry !== '' &&
    mailingZipCode !== '';

  const checkValidation = () => {
    if (age >= 18) {
      if (sameAddress) {
        setValidationError(
          !(
            siteInfoFilledOut &&
            intialFilledOut &&
            getEmailFilledOut &&
            addressFiledOut
          )
        );
        if (
          siteInfoFilledOut &&
          intialFilledOut &&
          getEmailFilledOut &&
          addressFiledOut
        ) {
          console.log('validation ok');
          return true;
        } else {
          return false;
        }
      } else {
        setValidationError(
          !(
            siteInfoFilledOut &&
            intialFilledOut &&
            getEmailFilledOut &&
            addressFiledOut &&
            mailingFiledOut
          )
        );
        if (
          siteInfoFilledOut &&
          intialFilledOut &&
          getEmailFilledOut &&
          addressFiledOut &&
          mailingFiledOut
        ) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      if (sameAddress) {
        setValidationError(
          siteInfoFilledOut &&
            !(intialFilledOut && getEmailFilledOut && addressFiledOut)
        );
        if (
          siteInfoFilledOut &&
          intialFilledOut &&
          getEmailFilledOut &&
          addressFiledOut
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        setValidationError(
          !(
            siteInfoFilledOut &&
            intialFilledOut &&
            parentsInfoFilledOut &&
            getEmailFilledOut &&
            addressFiledOut &&
            mailingFiledOut
          )
        );
        if (
          siteInfoFilledOut &&
          intialFilledOut &&
          parentsInfoFilledOut &&
          getEmailFilledOut &&
          addressFiledOut &&
          mailingFiledOut
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    try {
      if (checkValidation()) {
        console.log('onSubmit');
        submitData({ ...formData, age });
        // sendInterestEmail(formData)
        navigate('/interest-forms');
      }
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
      toast.error(`There was an error with this request. ${error.message}`);
    }
  };

  return (
    <AdminLayout>
    <Helmet>
        <meta charSet="utf-8" />
        <title>Add Interest Form</title>
         <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      {siteFieldSearchModal && (
        <SiteFieldSearchModal setFormData={setFormData} formData={formData} />
      )}
      {siteZipSearchModal && (
        <SiteZipSearchModal setFormData={setFormData} formData={formData} />
      )}
      <section id='add-interest'>
        <div className='container'>
          <h2 className='text-center top-title'>Add Interest Form</h2>
          <div className='search-modal-btns'>
            <div
              onClick={() => setFormModal('siteZipSearchModal', true)}
              className='btn btn-llac-light-green'
            >
              Search Site by Zip
            </div>
            <div
              onClick={() => setFormModal('siteFieldSearchModal', true)}
              className='btn btn-llac-light-green'
            >
              Search Site by Fields
            </div>
          </div>
          <form onSubmit={onSubmit} className='sub-forms form'>
            <div className='sub-form site-sub-form'>
              <h3>Selected Learning Center</h3>
              <div
                className='sum-item'
                style={{
                  borderBottom:
                    validationError && !siteInfoFilledOut
                      ? 'solid 2px #d8302f'
                      : 'none',
                }}
              >
                <h4>Site:</h4>
                <p>{learningCenterName}</p>
              </div>
              <div
                className='sum-item'
                style={{
                  borderBottom:
                    validationError && !siteInfoFilledOut
                      ? 'solid 2px #d8302f'
                      : 'none',
                }}
              >
                <h4>Charter:</h4>
                <p>{learningCenterCharter}</p>
              </div>
              <div
                className='sum-item'
                style={{
                  borderBottom:
                    validationError && !siteInfoFilledOut
                      ? 'solid 2px #d8302f'
                      : 'none',
                }}
              >
                <h4>Address:</h4>
                <p>{learningCenterAddress}</p>
              </div>
            </div>
            <div className='sub-form'>
              <h3>Student Information</h3>
              <div className='horizontal-flex'>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Student ID</h4>
                    {/* <FaIcons.FaAsterisk className="asterisk-icon" /> */}
                  </div>

                  <input
                    type='text'
                    name='studentId'
                    value={studentId}
                    onChange={(e) => onChangeForm(e)}
                  />
                </div>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Student Number</h4>
                    {/* <FaIcons.FaAsterisk className="asterisk-icon" /> */}
                  </div>

                  <input
                    type='text'
                    name='studentNumber'
                    value={studentNumber}
                    onChange={(e) => onChangeForm(e)}
                  />
                </div>
              </div>
              <div className='horizontal-flex'>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Student's First Name</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>

                  <input
                    type='text'
                    name='studentFirstName'
                    value={studentFirstName}
                    onChange={(e) => onChangeForm(e)}
                    style={{
                      borderColor:
                        validationError && studentFirstName === ''
                          ? '#d8302f'
                          : '#ccc',
                    }}
                  />
                </div>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Student's Last Name</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>

                  <input
                    type='text'
                    name='studentLastName'
                    value={studentLastName}
                    onChange={(e) => onChangeForm(e)}
                    style={{
                      borderColor:
                        validationError && studentLastName === ''
                          ? '#d8302f'
                          : '#ccc',
                    }}
                  />
                </div>
              </div>
              <div className='horizontal-flex'>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Student's Birth Date</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>

                  <input
                    type='date'
                    name='birthDate'
                    value={birthDate}
                    onChange={(e) => onChangeForm(e)}
                    style={{
                      borderColor:
                        validationError &&
                        (birthDate !== '' ||
                          birthDate !== moment(new Date()).format('YYYY-MM-DD'))
                          ? '#d8302f'
                          : '#ccc',
                    }}
                  />
                  <p className='date-remind'>{`The student is ${age} years old? If not, select birth date again`}</p>
                </div>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Grade Level</h4>
                    {/* <FaIcons.FaAsterisk className="asterisk-icon" /> */}
                  </div>

                  <select
                    name='gradeLevel'
                    value={gradeLevel}
                    onChange={(e) => onChangeForm(e)}
                  >
                    <option value=''>Select Grade Level</option>
                    <option value='9'>9</option>
                    <option value='10'>10</option>
                    <option value='11'>11</option>
                    <option value='12'>12</option>
                  </select>
                </div>
              </div>
            </div>
            {age < 18 && (
              <div className='sub-form'>
                <h3>{`Parent's Information`}</h3>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Your Relationship to {studentFirstName}:</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>

                  <select
                    name='parentRelationship'
                    value={parentRelationship}
                    onChange={(e) => onChangeForm(e)}
                    style={{
                      borderColor:
                        validationError && parentRelationship === ''
                          ? '#d8302f'
                          : '#ccc',
                    }}
                  >
                    <option value=''>Please make a selection</option>
                    {relationshipList.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                </div>
                <div className='horizontal-flex'>
                  <div className='sum-item'>
                    <div className='asterisk-group'>
                      <h4>{parentRelationship}'s First Name</h4>
                      <FaIcons.FaAsterisk className='asterisk-icon' />
                    </div>

                    <input
                      type='text'
                      name='parentFirstName'
                      value={parentFirstName}
                      onChange={(e) => onChangeForm(e)}
                      style={{
                        borderColor:
                          validationError && parentFirstName === ''
                            ? '#d8302f'
                            : '#ccc',
                      }}
                    />
                  </div>
                  <div className='sum-item'>
                    <div className='asterisk-group'>
                      <h4>{parentRelationship}'s Last Name</h4>
                      <FaIcons.FaAsterisk className='asterisk-icon' />
                    </div>

                    <input
                      type='text'
                      name='parentLastName'
                      value={parentLastName}
                      onChange={(e) => onChangeForm(e)}
                      style={{
                        borderColor:
                          validationError && parentLastName === ''
                            ? '#d8302f'
                            : '#ccc',
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className='sub-form'>
              <h3>
                {age >= 18 ? `Student's` : `${parentFirstName}'s`} Contact
                Information
              </h3>
              <div className='horizontal-flex'>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Email</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>

                  <input
                    type='text'
                    name='primaryEmail'
                    value={primaryEmail}
                    onChange={(e) => onChangeForm(e)}
                    style={{
                      borderColor:
                        validationError &&
                        (primaryEmail === '' || !validateEmail(primaryEmail))
                          ? '#d8302f'
                          : '#ccc',
                    }}
                  />
                  {validationError &&
                    primaryEmail !== '' &&
                    !validateEmail(primaryEmail) && (
                      <p className='validEmail'>
                        Please provide a valid email address
                      </p>
                    )}
                </div>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Phone Number</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>

                  <input
                    type='text'
                    name='phone'
                    value={phone}
                    onChange={(e) => onChangeForm(e)}
                    placeholder='XXX-XXX-XXXX'
                    style={{
                      borderColor:
                        validationError &&
                        (phone === '' || !validatePhone(phone))
                          ? '#d8302f'
                          : '#ccc',
                    }}
                  />
                  {validationError && phone !== '' && !validatePhone(phone) && (
                    <p className='validEmail'>
                      Please provide a valid phone number in the following
                      format XXX-XXX-XXXX
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className='sub-form'>
              <h3>{age >= 18 ? `Student's` : `Parent's`} Physical Address</h3>
              <div className='horizontal-flex'>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Street - Line 1</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>

                  <input
                    type='text'
                    name='street1'
                    value={street1}
                    onChange={(e) => onChangeForm(e)}
                    style={{
                      borderColor:
                        validationError && street1 === '' ? '#d8302f' : '#ccc',
                    }}
                  />
                </div>
                <div className='sum-item'>
                  <h4>Street - Line 2:</h4>
                  <input
                    type='text'
                    name='street2'
                    value={street2}
                    onChange={(e) => onChangeForm(e)}
                  />
                </div>
              </div>
              <div className='horizontal-flex'>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Country</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>
                  <select
                    name='country'
                    value={country}
                    onChange={(e) => onChangeForm(e)}
                    style={{
                      borderColor:
                        validationError && country === '' ? '#d8302f' : '#ccc',
                    }}
                  >
                    <option value=''>Please Select Country</option>
                    {countriesList.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                </div>
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>Zip/Postal Code</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>
                  <input
                    type='text'
                    name='zipCode'
                    value={zipCode}
                    onChange={(e) => onChangeForm(e)}
                    style={{
                      borderColor:
                        validationError && zipCode === '' ? '#d8302f' : '#ccc',
                    }}
                  />
                </div>
              </div>
              <div className='horizontal-flex'>
                {country === 'United States of America' || country === '' ? (
                  <div className='sum-item'>
                    <div className='asterisk-group'>
                      <h4>State</h4>
                      <FaIcons.FaAsterisk className='asterisk-icon' />
                    </div>

                    <select
                      name='state'
                      value={state}
                      onChange={(e) => onChangeForm(e)}
                      style={{
                        borderColor:
                          validationError && state === '' ? '#d8302f' : '#ccc',
                      }}
                    >
                      <option value=''>Please Select State</option>
                      {states.map((item) => {
                        return (
                          <option value={Object.keys(item)}>
                            {Object.keys(item)}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                ) : (
                  <div className='sum-item'>
                    <div className='asterisk-group'>
                      <h4>Region</h4>
                      <FaIcons.FaAsterisk className='asterisk-icon' />
                    </div>
                    <input
                      type='text'
                      name='region'
                      value={region}
                      onChange={(e) => onChangeForm(e)}
                      style={{
                        borderColor:
                          validationError &&
                          region === '' &&
                          country !== 'United States of America'
                            ? '#d8302f'
                            : '#ccc',
                      }}
                    />
                  </div>
                )}
                <div className='sum-item'>
                  <div className='asterisk-group'>
                    <h4>City</h4>
                    <FaIcons.FaAsterisk className='asterisk-icon' />
                  </div>

                  <input
                    type='text'
                    name='city'
                    value={city}
                    onChange={(e) => onChangeForm(e)}
                    style={{
                      borderColor:
                        validationError && city === '' ? '#d8302f' : '#ccc',
                    }}
                  />
                </div>
              </div>
              <div className='sum-item'>
                <h4>Same as Mailing Address:</h4>
                <input
                  type='checkbox'
                  name='sameAddress'
                  checked={sameAddress}
                  onChange={(e) => onChangeForm(e)}
                />
              </div>
            </div>
            {!sameAddress && (
              <div className='sub-form'>
                <h3>{age >= 18 ? `Student's` : `Parent's`} Mailing Address</h3>
                <div className='horizontal-flex'>
                  <div className='sum-item'>
                    <div className='asterisk-group'>
                      <h4>Street - Line 1</h4>
                      <FaIcons.FaAsterisk className='asterisk-icon' />
                    </div>
                    <input
                      type='text'
                      name='mailingStreet1'
                      value={mailingStreet1}
                      onChange={(e) => onChangeForm(e)}
                      style={{
                        borderColor:
                          validationError &&
                          mailingStreet1 === '' &&
                          !sameAddress
                            ? '#d8302f'
                            : '#ccc',
                      }}
                    />
                  </div>
                  <div className='sum-item'>
                    <h4>Street - Line 2:</h4>
                    <input
                      type='text'
                      name='mailingStreet2'
                      value={mailingStreet2}
                      onChange={(e) => onChangeForm(e)}
                    />
                  </div>
                </div>

                <div className='horizontal-flex'>
                  <div className='sum-item'>
                    <div className='asterisk-group'>
                      <h4>Country</h4>
                      <FaIcons.FaAsterisk className='asterisk-icon' />
                    </div>

                    <select
                      name='mailingCountry'
                      value={mailingCountry}
                      onChange={(e) => onChangeForm(e)}
                      style={{
                        borderColor:
                          validationError &&
                          mailingCountry === '' &&
                          !sameAddress
                            ? '#d8302f'
                            : '#ccc',
                      }}
                    >
                      <option value=''>Please Select Country</option>
                      {countriesList.map((item) => {
                        return <option value={item}>{item}</option>;
                      })}
                    </select>
                  </div>
                  <div className='sum-item'>
                    <div className='asterisk-group'>
                      <h4>Zip/Postal Code</h4>
                      <FaIcons.FaAsterisk className='asterisk-icon' />
                    </div>
                    <input
                      type='text'
                      name='mailingZipCode'
                      value={mailingZipCode}
                      onChange={(e) => onChangeForm(e)}
                      style={{
                        borderColor:
                          validationError &&
                          mailingZipCode === '' &&
                          !sameAddress
                            ? '#d8302f'
                            : '#ccc',
                      }}
                    />
                  </div>
                </div>

                <div className='horizontal-flex'>
                  {mailingCountry === 'United States of America' ||
                  mailingCountry === '' ? (
                    <div className='sum-item'>
                      <div className='asterisk-group'>
                        <h4>State</h4>
                        <FaIcons.FaAsterisk className='asterisk-icon' />
                      </div>
                      <select
                        name='mailingState'
                        value={mailingState}
                        onChange={(e) => onChangeForm(e)}
                        style={{
                          borderColor:
                            validationError &&
                            mailingState === '' &&
                            !sameAddress &&
                            (mailingCountry === 'United States of America' ||
                              mailingCountry === '')
                              ? '#d8302f'
                              : '#ccc',
                        }}
                      >
                        <option value=''>Please Select State</option>
                        {states.map((item) => {
                          return (
                            <option value={Object.keys(item)}>
                              {Object.keys(item)}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  ) : (
                    <div className='sum-item'>
                      <div className='asterisk-group'>
                        <h4>Region</h4>
                        <FaIcons.FaAsterisk className='asterisk-icon' />
                      </div>
                      <input
                        type='text'
                        name='mailingRegion'
                        value={mailingRegion}
                        onChange={(e) => onChangeForm(e)}
                        style={{
                          borderColor:
                            validationError &&
                            mailingState === '' &&
                            !sameAddress &&
                            mailingCountry !== 'United States of America'
                              ? '#d8302f'
                              : '#ccc',
                        }}
                      />
                    </div>
                  )}
                  <div className='sum-item'>
                    <div className='asterisk-group'>
                      <h4>City</h4>
                      <FaIcons.FaAsterisk className='asterisk-icon' />
                    </div>
                    <input
                      type='text'
                      name='mailingCity'
                      value={mailingCity}
                      onChange={(e) => onChangeForm(e)}
                      style={{
                        borderColor:
                          validationError && mailingCity === '' && !sameAddress
                            ? '#d8302f'
                            : '#ccc',
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <input
              type='submit'
              value='Submit'
              className='btn btn-llac-dark-green'
            />
          </form>
        </div>
      </section>
    </AdminLayout>
  );
};

export default AddInterestPage;
